import * as Bowser from "bowser";
import { IdCookies } from "../../constants/IdCookies";
import { IdPersistence } from "../../constants/IdPersistence";
import { IdTrackingConnection } from "../../constants/IdTrackingConnection";
import { SessionType } from "../../features/game-tracking/types/SessionTypeEnum";
import { errorTracking, logTracking } from "../logging/logging";
import { StatusCode } from "../network/generated/protoTypes";
import { PersistenceMode } from "../PersistenceMode";
import { utilCookie } from "../utilCookie";
import { utilPersistence } from "../utilPersistence";
import { utilTime } from "../utilTime";
import { utilWebService } from "../utilWebService";
var UtilTracking = /** @class */ (function () {
    function UtilTracking() {
        var _this = this;
        this.gameStateCount = 1;
        this.shopStateCount = 1;
        this.startTime = utilTime.now();
        this.headers = IdTrackingConnection.Header;
        this.url = IdTrackingConnection.Url;
        this.getGameSessionCount = function () {
            return _this.gameSessionCount;
        };
        this.getGameStateCount = function () {
            return _this.gameStateCount++;
        };
        this.getShopStateCount = function () {
            return _this.shopStateCount++;
        };
        this.getAccountHash = function () {
            return _this.accountHash;
        };
        this.getTimeSinceStart = function () {
            return utilTime.now() - _this.startTime;
        };
        this.getStartTime = function () {
            return Math.round(_this.startTime / 1000);
        };
        this.getStartDateTime = function () { return _this.startTime; };
        this.getGameClientTimeStamp = function () {
            var currentTime = utilTime.now();
            return Math.round(utilTime.msToSeconds(currentTime));
        };
        this.getGameSessionType = function () {
            if (_this.gameSessionCount === 1) {
                return SessionType.FIRST_SESSION;
            }
            else {
                return SessionType.REGULAR_SESSION;
            }
        };
        this.getLandingPageCredentials = function () {
            return utilPersistence.getValue(IdPersistence.Credentials, {});
        };
        this.getOperativeSystem = function () {
            if (_this.parser != undefined) {
                return _this.parser.getOSName() + " " + _this.parser.getOSVersion();
            }
            return "unknown";
        };
        this.getBrowserName = function () {
            if (_this.parser != undefined) {
                return _this.parser
                    .getBrowserName()
                    .toLowerCase() + " " + _this.parser.getBrowserVersion();
            }
            return "unknown";
        };
        this.postTrackingData = function (eventJSON, trackingName, logMessage, onResponse, onError) {
            logTracking(logMessage);
            var isAsync = true;
            var headers = _this.getXMLHeaders();
            var handleResponse = function (xmlRequest) { return function () {
                _this.handleXmlResponse(xmlRequest, trackingName);
                if (onResponse != undefined) {
                    onResponse(xmlRequest);
                }
            }; };
            var handleError = function (xmlRequest) { return function (error) {
                errorTracking("Tracking " + trackingName + " catchError: " + error.error);
                if (onError != undefined) {
                    onError(xmlRequest, error);
                }
            }; };
            utilWebService.httpPost(_this.url, headers, eventJSON, isAsync, handleResponse, handleError);
        };
        this.getXMLHeaders = function () {
            var headers = new Map();
            Object.keys(_this.headers).forEach(function (key) { return headers.set(key, _this.headers[key]); });
            return headers;
        };
        this.generateAccountHash = function () {
            var trackingData = _this.getTrackingData();
            var hash = "";
            if (trackingData.accountHash && trackingData.accountHash.length > 1) {
                hash = trackingData.accountHash;
            }
            else {
                hash = utilCookie.read(IdCookies.JourneyHash, _this.getParameterByName("journeyHash") || "");
            }
            return hash;
        };
        this.getParameterByName = function (name, url) {
            if (!url) {
                url = window.location.href;
            }
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
            var results = regex.exec(url);
            if (!results) {
                return undefined;
            }
            if (!results[2]) {
                return "";
            }
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        };
        this.getTrackingData = function () {
            return utilPersistence.getValue(IdPersistence.Tracking, {
                accountHash: "",
                gameSessionCount: 1,
            });
        };
        this.updateTrackingData = function () {
            var data = _this.getTrackingData();
            if (data.accountHash && data.accountHash.length > 1) {
                _this.gameSessionCount = ++_this.gameSessionCount;
                _this.accountHash = data.accountHash;
            }
            else {
                _this.accountHash = utilCookie.read(IdCookies.JourneyHash, "");
                _this.gameSessionCount = 1;
            }
            data.accountHash = _this.accountHash;
            data.gameSessionCount = _this.gameSessionCount;
            utilPersistence.setValue(IdPersistence.Tracking, data, PersistenceMode.Update);
        };
        this.handleXmlResponse = function (xmlRequest, trackingName) {
            var responseFailed = xmlRequest.status !== StatusCode.OK;
            if (responseFailed) {
                errorTracking("Tracking " + trackingName + " Request failed.  Returned status of: " + xmlRequest.status);
            }
        };
        var trackingData = this.getTrackingData();
        this.gameSessionCount = trackingData.gameSessionCount || 1;
        this.accountHash = this.generateAccountHash();
        this.updateTrackingData();
        this.parser = Bowser.getParser(navigator.userAgent);
    }
    Object.defineProperty(UtilTracking.prototype, "referrer", {
        get: function () {
            return this._referrer || document.referrer;
        },
        set: function (value) {
            this._referrer = value;
        },
        enumerable: true,
        configurable: true
    });
    return UtilTracking;
}());
export var utilTracking = new UtilTracking();



//////////////////
// WEBPACK FOOTER
// ./src/utils/tracking/utilTracking.ts
// module id = 281
// module chunks = 3